import React, { useEffect, useMemo, useRef, useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import CardLarge1 from "components/CardLarge1/CardLarge1";
import NextPrev from "components/NextPrev/NextPrev"

function useInterval(callback, delay) {
  const savedCallback = useRef();

  useEffect(() => {
    savedCallback.current = callback;
  }, [callback]);

  useEffect(() => {
    function tick() {
      savedCallback.current();
    }
    if (delay !== null) {
      let id = setInterval(tick, delay);
      return () => clearInterval(id);
    }
  }, [delay]);
}

// Animacja przesuwania
// const variants = {
//   enter: (direction) => ({
//     x: direction > 0 ? 300 : -300,
//     opacity: 0,
//     position: "relative",
//     width: "100%",
//   }),
//   center: {
//     x: 0,
//     opacity: 1,
//     position: "relative",
//     width: "100%",
//   },
//   exit: (direction) => ({
//     x: direction < 0 ? 300 : -300,
//     opacity: 0,
//     position: "relative",
//     width: "100%",
//   }),
// };

const SectionLargeSlider = ({
  posts,
  heading = "Editor's pick",
  className = "",
}) => {
  const [indexActive, setIndexActive] = useState(0);
  const [isReady, setIsReady] = useState(false);
  const [direction, setDirection] = useState(0); // -1 = prev, 1 = next

  const filtered = useMemo(
    () => posts.slice(0,4),
    [posts]
  );

  const handleClickNext = () => {
    setDirection(1);
    setIndexActive((state) =>
      state >= filtered.length - 1 ? 0 : state + 1
    );
  };

  const handleClickPrev = () => {
    setDirection(-1);
    setIndexActive((state) =>
      state === 0 ? filtered.length - 1 : state - 1
    );
  };

  useEffect(() => {
    const preloadImage = (url) => {
      const link = document.createElement("link");
      link.rel = "preload";
      link.as = "image";
      link.href = url;
      document.head.appendChild(link);
      return link;
    };
  
    const current = filtered[indexActive];
    const next = filtered[(indexActive + 1) % filtered.length];
  
    const links = [];
  
    if (current?.image) links.push(preloadImage(current.image));
    if (next?.image) links.push(preloadImage(next.image));
  
    return () => {
      links.forEach((link) => document.head.removeChild(link));
    };
  }, [filtered, indexActive]);
  useEffect(() => {
    // Po załadowaniu komponentu ustawiamy gotowość slajdu
    setIsReady(true);
  }, []);

  useInterval(handleClickNext, 7000);

  return (
    <div className={`nc-SectionLargeSlider relative overflow-hidden ${className}`}>
      {/* {!!heading && <Heading>{heading}</Heading>} */}
      <AnimatePresence mode="wait" custom={direction}>
        <motion.div
          key={indexActive}
          custom={direction}
          // variants={variants}
          initial="enter"
          animate={['center', 'visible']}
          exit="exit"
          style={{
            opacity: isReady ? 1 : 0, // Zapewniamy płynność
            visibility: isReady ? "visible" : "hidden", // Ukrywamy do momentu gotowości
          }}
          transition={{ duration: 0.1, ease: "easeInOut" }}
        >
          <CardLarge1
            style={{ display: "flex", flexDirection: "column" }}
            post={filtered[indexActive]}
            isActive={true}
            fetchPriority={indexActive === 0 ? "high" : "auto"}
          />
        </motion.div>
      </AnimatePresence>
      <div
          style={{ top: "0%", position: "relative", left:"50%", transform: 'translateX(-50%)', justifyContent: 'center' }}
          className="p-1 sm:pt-8 sm:px-10"
        >
          <NextPrev
            btnClassName="w-11 h-11 text-xl"
            onClickNext={handleClickNext}
            onClickPrev={handleClickPrev}
          />
        </div>
    </div>
  );
};

export default SectionLargeSlider;
